import React from 'react'

const Frontend = () => {
  return (
    <div className='skills__content'>
    <h3 className='skills__title'>Front-end</h3>

    <div className='skill__box'>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                            <div>
                    <h3 className='skills__name'>Html</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                <div>
                    <h3 className='skills__name'>CSS</h3>
                    <span className='skills__level'> </span>
                </div>
            </div>
            
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                <div>
                    <h3 className='skills__name'>Sass</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                <div>
                    <h3 className='skills__name'>JS</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
        </div>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                <div>
                    <h3 className='skills__name'>React</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                <div>
                    <h3 className='skills__name'>Bootstrap</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                <div>
                    <h3 className='skills__name'>jQuery</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-desktop' ></i>                <div>
                    <h3 className='skills__name'>TypeScript</h3>
                </div>
            </div>
            
        </div>
        
    </div>
</div>
  )
}

export default Frontend